<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['cpi_adv','cpa_adv'].map(v => {
			return { value: v, label: v.substr(0,3).toUpperCase() };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

